import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { dig } from 'spiceutils';

import { Select } from 'spicecomponents';

/*
 * SingleAnswer
 *
 * Renders a single select populated by the options passed in via the controlList. Includes logic
 * for data cleanup before passing back to the CDF.
 */
const AnswersToShow = (props) => {
  const getValueFromProps = () => dig(props.cdf, ['AnswersToShow', 0]) !== undefined ? Object.values(props.cdf.AnswersToShow[0])[0] : '';
  const getOptionsFromProps = () => {
    let answers = props.controlList.AnswersToShow.Options.Answers;
    answers = answers.map((answer) => {
      const answerNameAndId = Object.entries(answer)[0];
      return {
        value: answerNameAndId[0],
        text: answerNameAndId[1],
        data: {
          type: 'answer',
        },
      };
    });
    let nets = props.controlList.AnswersToShow.Options.Nets;
    nets = nets.map((net) => ({
      value: Object.keys(net)[0],
      data: {
        type: 'net',
      },
    }));
    return [{ value: 'None', text: 'Default' }].concat(
      answers,
      nets
    );
  };
  const onChange = (value, optionData) => {
    const type = optionData.type;
    switch (type) {
      case 'answer':
        props.updateCDF('AnswersToShow', [{ Value: value }]);
        break;
      case 'net':
        props.updateCDF('AnswersToShow', [{ Net: value }]);
        break;
      default:
        props.updateCDF('AnswersToShow', null);
    }
  };
  return (
    <Div>
      <label htmlFor="answersToShow">Options</label>
      <Select name="answersToShow" value={getValueFromProps()} onChange={onChange} options={getOptionsFromProps()} />
    </Div>
  );
};

const Div = styled.div`
  margin-bottom: 30px;
`;

AnswersToShow.propTypes = {
  updateCDF: PropTypes.func,
};

export default AnswersToShow;



// WEBPACK FOOTER //
// ./app/components/FormControls/AnswersToShow/SingleAnswer.js